import {TimerBarProps} from "@/components/blocks/event-rotating-image-block/types";

export const TimerBar = ({paused, duration, reduceMotion}: TimerBarProps) => {
    return (
        <div className={"absolute left-0 right-0 top-0 h-1 w-full z-30"}
             style={{
                 backgroundColor: "rgba(255, 255, 255, 0.25)",
             }}
             aria-hidden>
            <div
                className={"absolute h-full bg-black/60 z-40"}
                style={{
                    width: "100%",
                    animation: reduceMotion || paused
                        ? "none"
                        : `timer-progress ${duration}ms linear forwards`,
                    transformOrigin: "left",
                }}
            />
        </div>
    );
};

